export enum AsyncComponentOptionalEnum {
    OptionalMutate = 'OptionalMutate',
    OptionalTabs = 'OptionalTabs',
    OptionalList = 'OptionalList',
    OptionalListForm = 'OptionalListForm',
    OptionalMutateForm = 'OptionalMutateForm',
    OptionalDetailMutateForm = 'OptionalDetailMutateForm',
    OptionalDetailMutate = 'OptionalDetailMutate',
    OptionalDetailListForm = 'OptionalDetailListForm',
    OptionalDetailList = 'OptionalDetailList',
    OptionalSelector = 'OptionalSelector',
    OptionalDetailSelector = 'OptionalDetailSelector',
    OptionalVisibilityGate = 'OptionalVisibilityGate',
    AccessoryMutate = 'AccessoryMutate',
    AccessoryTabs = 'AccessoryTabs',
    AccessoryList = 'AccessoryList',
    AccessoryMutateForm = 'AccessoryMutateForm',
    AccessorySelector = 'AccessorySelector',


}

export const optionalComponents = {
    [ AsyncComponentOptionalEnum.OptionalListForm ]: () => import( '@/components/optional/OptionalListForm.vue' ),
    [ AsyncComponentOptionalEnum.OptionalMutateForm ]: () => import( '@/components/optional/OptionalMutateForm.vue' ),
    [ AsyncComponentOptionalEnum.OptionalMutate ]: () => import( '@/views/optional/optionalMutate/OptionalMutate.vue' ),

    [ AsyncComponentOptionalEnum.OptionalTabs ]: () => import( '@/components/optional/OptionalTabs.vue' ),
    [ AsyncComponentOptionalEnum.OptionalList ]: () => import( '@/views/optional/optionalList/OptionalList.vue' ),
    [ AsyncComponentOptionalEnum.OptionalDetailMutateForm ]: () => import( '@/components/optional/OptionalDetailMutateForm.vue' ),
    [ AsyncComponentOptionalEnum.OptionalDetailMutate ]: () => import( '@/views/optional/optionalDetailMutate/OptionalDetailMutate.vue' ),
    [ AsyncComponentOptionalEnum.OptionalDetailListForm ]: () => import( '@/components/optional/OptionalDetailListForm.vue' ),
    [ AsyncComponentOptionalEnum.OptionalDetailList ]: () => import( '@/views/optional/optionalDetailList/OptionalDetailList.vue' ),
    [ AsyncComponentOptionalEnum.OptionalSelector ]: () => import( '@/components/optional/OptionalSelector.vue' ),
    [ AsyncComponentOptionalEnum.OptionalDetailSelector ]: () => import( '@/components/optional/OptionalDetailSelector.vue' ),
    [ AsyncComponentOptionalEnum.OptionalVisibilityGate ]: () => import( '@/components/optional/OptionalVisibilityGate.vue' ),
    [ AsyncComponentOptionalEnum.AccessoryMutate ]: () => import( '@/views/optional/accessoryMutate/AccessoryMutate.vue' ),
    [ AsyncComponentOptionalEnum.AccessoryTabs ]: () => import( '@/components/optional/AccessoryTabs.vue' ),
    [ AsyncComponentOptionalEnum.AccessoryList ]: () => import( '@/views/optional/accessoryList/AccessoryList.vue' ),
    [ AsyncComponentOptionalEnum.AccessoryMutateForm ]: () => import( '@/components/optional/AccessoryMutateForm.vue' ),
    [ AsyncComponentOptionalEnum.AccessorySelector ]: () => import( '@/components/optional/AccessorySelector.vue' ),
}
